import { CustomColumn } from '@dcl/ui/dist/fragments/DataGrid/DataGridTypes';

import { ISupportHours, ISupportHoursTableHeader } from './SupportHoursTypes';

export const data = [
  {
    tabTitle: 'Customer Support',
    scheduleId: '1',
  },
  {
    tabTitle: 'Technical Support',
    scheduleId: '2',
  },
];

export const mockSupportHoursProps: ISupportHours = {
  heading: 'UltraTax CS support schedule',
  title: 'Support hours',
  description:
    'Search or use the filters below to explore all support hours by quarter, days or times.',
  apiUrlHost:
    'https://j5ox4lzgo6.execute-api.us-east-1.amazonaws.com/dev/a208273-genesys-api-dev',
  supportInfo: [
    {
      tabLabel: 'Technical support',
      normalHoursLabel: 'Normal hours',
      phoneNumberLabel: 'Phone number',
      supportType: 'Weekdays',

      phoneNumberValue: '+3-234-322-3220',
      phoneNumberExtensionValue: '(option 2)',
      scheduleGroupID: 'onesource-income-tax_en-us',
    },
    {
      tabLabel: 'Customer support',
      normalHoursLabel: 'Normal hours',
      phoneNumberLabel: 'Phone number',
      supportType: 'Weekdays',
      phoneNumberValue: '+1-234-567-8900',
      phoneNumberExtensionValue: '(option 1)',
      scheduleGroupID: 'ultratax-cs_en-us',
    },
  ],
};

export const mockSupportHoursWithoutTabs: ISupportHours = {
  heading: 'UltraTax CS support schedule',
  title: 'Support hours',
  description:
    'Search or use the filters below to explore all support hours by quarter, days or times.',
  apiUrlHost:
    'https://j5ox4lzgo6.execute-api.us-east-1.amazonaws.com/dev/a208273-genesys-api-dev',
  supportInfo: [
    {
      tabLabel: 'Customer support',
      normalHoursLabel: 'Normal hours',
      phoneNumberLabel: 'Phone number',
      supportType: 'Weekdays',
      phoneNumberValue: '+1-234-567-8900',
      phoneNumberExtensionValue: '(option 1)',
      scheduleGroupID: 'onesource-income-tax_en-us',
    },
  ],
};

export const tableData: ISupportHoursTableHeader[] = [
  { Quarter: 'Quarter 1', Date: 'January 1', Day: 'Wednesday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 4', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 5', Day: 'Sunday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 11', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 12', Day: 'Sunday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 18', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 19', Day: 'Sunday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 25', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'January 26', Day: 'Sunday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'February 1', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'February 2', Day: 'Sunday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'February 8', Day: 'Saturday', Time: 'Closed' },
  { Quarter: 'Quarter 1', Date: 'February 9', Day: 'Sunday', Time: 'Closed' },
  {
    Quarter: 'Quarter 1',
    Date: 'February 15',
    Day: 'Saturday',
    Time: 'Closed',
  },
  { Quarter: 'Quarter 1', Date: 'February 16', Day: 'Sunday', Time: 'Closed' },
  {
    Quarter: 'Quarter 1',
    Date: 'February 22',
    Day: 'Saturday',
    Time: 'Closed',
  },
  { Quarter: 'Quarter 1', Date: 'February 23', Day: 'Sunday', Time: 'Closed' },
  {
    Quarter: 'Quarter 1',
    Date: 'March 1',
    Day: 'Saturday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 2',
    Day: 'Sunday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 8',
    Day: 'Saturday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 9',
    Day: 'Sunday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 15',
    Day: 'Saturday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 16',
    Day: 'Sunday',
    Time: '9 AM to 6 PM',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 17',
    Day: 'Monday',
    Time: '8 AM to Midnight',
  },
  {
    Quarter: 'Quarter 1',
    Date: 'March 22',
    Day: 'Saturday',
    Time: '9 AM to 6 PM',
  },
];

export const tableHeadings: CustomColumn<Record<string, string | number>>[] = [
  {
    Header: 'Quarter',
    accessor: 'col1',
    sortable: true,
    sortingAriaLabel: 'sort by Quarter',
    className: 'SupportHoursTable-Quarter',
    filterable: true,
  },
  {
    Header: 'Date',
    accessor: 'col2',
    sortable: true,
    sortingAriaLabel: 'sort by Date',
    className: 'SupportHoursTable-Date',
    filterable: true,
  },
  {
    Header: 'Day',
    accessor: 'col3',
    sortable: true,
    sortingAriaLabel: 'sort by Day',
    className: 'SupportHoursTable-Day',
    filterable: true,
  },
  {
    Header: 'Time',
    accessor: 'col4',
    sortable: true,
    sortingAriaLabel: 'sort by Time',
    className: 'SupportHoursTable-Time',
    filterable: true,
  },
];

export const tableBodyData = [
  { col1: 'Quarter 1', col2: 'January 1', col3: 'Wednesday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 4', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 5', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 11', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 12', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 18', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 19', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 25', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'January 26', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 1', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 2', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 8', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 9', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 15', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 16', col3: 'Sunday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 22', col3: 'Saturday', col4: 'Closed' },
  { col1: 'Quarter 1', col2: 'February 23', col3: 'Sunday', col4: 'Closed' },
  {
    col1: 'Quarter 1',
    col2: 'March 1',
    col3: 'Saturday',
    col4: '9 AM to 6 PM',
  },
  { col1: 'Quarter 1', col2: 'March 2', col3: 'Sunday', col4: '9 AM to 6 PM' },
  {
    col1: 'Quarter 1',
    col2: 'March 8',
    col3: 'Saturday',
    col4: '9 AM to 6 PM',
  },
  { col1: 'Quarter 1', col2: 'March 9', col3: 'Sunday', col4: '9 AM to 6 PM' },
  {
    col1: 'Quarter 1',
    col2: 'March 15',
    col3: 'Saturday',
    col4: '9 AM to 6 PM',
  },
  { col1: 'Quarter 1', col2: 'March 16', col3: 'Sunday', col4: '9 AM to 6 PM' },
  {
    col1: 'Quarter 1',
    col2: 'March 17',
    col3: 'Monday',
    col4: '8 AM to Midnight',
  },
  {
    col1: 'Quarter 1',
    col2: 'March 22',
    col3: 'Saturday',
    col4: '9 AM to 6 PM',
  },
];

export const FILTER_MOCK_DATA = [
  {
    accessor: 'col1',
    cols: [
      {
        option: '101e',
        selected: false,
      },
      {
        option:
          'Microsoft ended support for SQL 2012 and earlier on July 12, 2022. You should have SQL Server 2014 (Service Pack 3) or higher installed on machines that run Accounting CS.',
        selected: false,
      },
      {
        option:
          'zebra Microsoft ended support for SQL 2012 and earlier on July 12, 2022. You should have SQL Server 2014 (Service Pack 3) or higher installed on machines that run Accounting CS.',
        selected: false,
      },
    ],
    header: 'Title',
  },
  {
    accessor: 'col2',
    cols: [
      {
        option: 'Refer to ADO #758624 when talking to Support',
        selected: false,
      },
      {
        option: 'yaak Refer to ADO #758624 when talking to Support',
        selected: false,
      },
    ],
    header: 'Category',
  },
];

//test mocks
export const columnData1 = [
  { filterable: true, Header: 'Status', accessor: 'status' },
  { filterable: false, Header: 'Name', accessor: 'name' },
];

export const mobileData1 = [
  { status: 'Open', originalstatus: 'Open' },
  { status: 'Closed', originalstatus: 'Closed' },
  { status: 'Open', originalstatus: 'Open' },
];

export const result1 = [
  {
    header: 'Status',
    cols: [
      { option: 'Closed', selected: false },
      { option: 'Open', selected: false },
    ],
    accessor: 'status',
  },
];

export const columnData2 = [
  { filterable: true, Header: 'Status', accessor: 'status' },
];
const ReactElement = { props: { children: 'Pending' } };
export const mobileData2 = [
  { status: 'Pending', originalstatus: ReactElement },
];

export const data1 = [
  { status: 'Open', originalstatus: 'Open' },
  { status: 'Closed', originalstatus: 'Closed' },
  { status: 'Pending', originalstatus: 'Pending' },
];
export const filters1 = [
  {
    accessor: 'status',
    cols: [
      { option: 'Open', selected: true },
      { option: 'Closed', selected: false },
      { option: 'Pending', selected: false },
    ],
  },
];

export const data2 = [
  { status: 'Open', originalstatus: 'Open' },
  { status: 'Closed', originalstatus: 'Closed' },
];
export const filters2 = [
  {
    accessor: 'status',
    cols: [
      { option: 'Open', selected: false },
      { option: 'Closed', selected: false },
    ],
  },
];

export const data3 = [
  { status: 'Pending', originalstatus: ReactElement },
  { status: 'Closed', originalstatus: 'Closed' },
];
export const filters3 = [
  {
    accessor: 'status',
    cols: [
      { option: 'Pending', selected: true },
      { option: 'Closed', selected: false },
    ],
  },
];

export const scheduleData1 = [
  {
    date: '2024-06-01T00:00:00Z',
    isClosed: 'False',
    openDate_UTC: '2024-06-01T13:00:00Z',
    closedDate_UTC: '2024-06-01T21:00:00Z',
  },
];

export const scheduleData2 = [
  {
    date: '2024-01-15T00:00:00Z',
    isClosed: 'True',
    openDate_UTC: '2024-01-15T13:00:00Z',
    closedDate_UTC: '2024-01-15T21:00:00Z',
  },
];

export const searchMockData = [
  {
    col1: 'Quarter 2',
    col2: 'June 1',
    col3: 'Saturday',
    col4: '08:00 to 17:00',
  },
  { col1: 'Quarter 3', col2: 'July 2', col3: 'Sunday', col4: 'Closed' },
];
